export default __webpack_public_path__ + "static/media/icon_infrastructure.581cba55.svg";